module.exports = __webpack_public_path__ + "img/teasers_10.572d4acc.jpg";